import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'minpercent',
    standalone: false
})
export class MinPercent implements PipeTransform {
  transform(value: number, min = 1): string {
    return value * 100 >= min ? `${Math.round(value * 100).toFixed(0)}%` : `<${min}%`;
  }
}
